/* eslint-disable @typescript-eslint/no-unused-expressions */
import { CubeContext } from "@cubejs-client/react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { hasInvalidCubePayload } from "../../../../Utils/UtilFunctions/cubeUtil";
import fetchAndTrackCubeQuery from "../../../../Utils/UtilFunctions/trackedCubeQuery";
import ReportHeader from "../../components/ReportHeader";
import AccordionKPIBlock from "./HyPETReportView/AccordionKPIBlock";
import { Plant } from "../../../../models/Types_Interfaces";
import { AppContext } from "../../../../App";
import ContentSubHeader from "../../components/ContentSubHeader";
import { useInjectionDataContext } from "../../contexts/InjectionDataContext";
import { env } from "../../../../env";
import { useLocation } from "react-router-dom";
import buildBreadCrumbs from "../../utils/buildBreadCrumb";
import useFetchAssetData from "../../Hooks/fetchAssetsHook";
import LoadingIndicator from "../../components/Loading";
import ErrorIndicator from "../../components/Error";
const baseURL = env?.microservice_assetsmgt;

type UpdateTroubleShootMode = "addTag" | "removeTag";
const ASSET_COLOR = "#adebb3";
const range = [
  moment
    .tz("America/Los_Angeles")
    .subtract(12, "hours")
    .format("YYYY-MM-DDTHH:mm:ss.000"),
  moment.tz("America/Los_Angeles").format("YYYY-MM-DDTHH:mm:ss.000"),
];

function TimeSeriesView() {
  const { sharedData } = useInjectionDataContext();
  const location = useLocation();
  const { assetId, tag, parentId, hypetId, hypetChildId, hypetSubChildId, asset } = location.state;
  const { hypet, hypetchild, hypetsubchild } = useParams();
  const topRef: any = useRef(null);
  const { cubejsApi } = React.useContext(CubeContext);
  const plantsList: Plant[] = useSelector(
    (state: any) => state.plantsList.plants
  );
  const { selectedPlantForCube }: any = useContext(AppContext);
  const dispatch = useDispatch();
  const [kpiDataHyPET, setKpiDataHyPET] = useState([]);
  const seedsList = useSelector((state: any) => state.seedsList);
  const [collapsed, setCollapsed] = useState<boolean[]>([]); // Track collapse state for each graph
  const [extended, setExtended] = useState<boolean[]>([]);
  const [currentAssetId, setCurrentAssetId] = useState<any>(null);
  const [excelData, setExcelData] = useState<any>([]);
  const [finalExcelData, setFinalExcelData] = useState<any>([]);
  const [refresh, setRefresh] = React.useState<any>(false);
  const [fetchedAnnotations, setFetchedAnnotations] = React.useState<any>([]);
  const [expandedItems, setExpandedItems] = useState<any>({});
  const [collapsedItems, setCollapsedItems] = useState<any>({});
  const [compareAssets, setCompareAssets] = useState<any[]>([]);
  const levelsList = useSelector((state: any) => state.levelsList);
  const [updatedKpiList, setUpdatedKpiList] = useState<any[]>([]);
  const [queryKey, setQueryKey] = useState<string>(`initial_call_${assetId}_${moment().valueOf()}`);
  const [isAssetHasSubCategoryValue, setIsAssetHasSubCategoryValue] = useState<boolean>(false);
  const [subCategoryData, setSubCategoryData] = useState<any[]>([]);
  const [expandedMainAccordion, setExpandedMainAccordion] = useState<number | null>(null);
  const [timeGranularity, setTimeGranularity] = useState<any>("minute");
  const [timeDimensions, setTimeDimensions] = useState<any>(range);
  const [measureType, setMeasureType] = useState<any>("FiveMinAgg");
    const {
    data: hypet_single_assets,
    error,
    isLoading,
  } = useFetchAssetData(
    `${baseURL}assets/${assetId}`,
    queryKey,
    `hypet_assets_${sharedData[0].plantId}_${assetId}`
  );

  const filteredHyPETSingleAsset = hypet_single_assets?.data;

  const selectedPlant = useMemo(
    () =>
      plantsList.find(
        ({ plant_code }) => plant_code === selectedPlantForCube
      ) as Plant,
    [plantsList, selectedPlantForCube]
  );
  const localStorageCompareKey =
    selectedPlant.plant_code + "-injection-pdm-compare";

  const getParentAsset = (childAsset: any) =>
    childAsset?.parent_asset
      ? levelsList.levels.find((asset: any) => {
          return asset._id === childAsset.parent_asset;
        })
      : null;

  const plantList = useSelector((state: any) => state.plantsList);
  const plantName =
    plantList.plants.find((item: any) => item.plant_code === selectedPlantForCube)
    ?.plant_name || "";

  const updateTroubleShootData = (
    newTag: any,
    mode: UpdateTroubleShootMode,
    moldAssetName: string
  ) => {
    if (!filteredHyPETSingleAsset) return;
    let subAsset3: any = {};
    let moldAsset: any = {};
    let subAssetTags: any = [];
    let moldSubCategory: any = []
    let moldAssetTags: any = [];
    let assetPreFix: string = tag?.slice(0,3)

    const parentAsset = {
      label: `${assetPreFix} HyPETs`, // need to update pant number
      value: "",
      key: `${assetPreFix} HyPETs`,
      id: parentId,
      color: ASSET_COLOR,
    };

    const subAsset = {
      label: `${assetPreFix} ${hypet}`, // need to update pant number
      value: tag,
      key: `${assetPreFix} ${hypet}`,
      id: hypetId,
      color: ASSET_COLOR,
      prefix: hypet,
    };

    const subAsset2: any = {
      label: `${hypet} ${hypetchild}`,
      value: `${hypet} ${hypetchild}`,
      key: `${hypet} ${hypetchild}`,
      parent: hypet,
      tag: tag,
      color: ASSET_COLOR,
      prefix: hypet,
      id: hypetChildId,
    };

    if (asset?.kpiDataPoints?.length) {
      asset?.kpiDataPoints?.forEach((tagObj: any) => {
        subAssetTags.push(tag + tagObj?.kpitag);
      });
    }
    if (
      hypetchild &&
      hypetchild !== "" &&
      asset?.asset_alias?.toLowerCase()?.includes("machines")
    ) {
      subAsset2["tagCollection"] = subAssetTags;
    }

    if(asset?.subCategory?.length) {
      moldSubCategory = asset?.subCategory
      asset?.subCategory?.forEach((item: any) => {
        item?.kpiDataPoints?.forEach((tagObj: any) => {
          if (typeof tagObj?.kpitag === "string") {
            moldAssetTags.push(tag + tagObj?.kpitag);
          } else {
            tagObj?.kpitag.forEach((subTag: any) => {
              moldAssetTags.push(tag + subTag);
            });
          }
        });
      });
    }

    if(hypetsubchild && hypetsubchild !== "") {
      subAsset3 = {
        label: `${hypet} ${hypetsubchild}`,
        value: `${hypet} ${hypetsubchild}`,
        key: `${hypet} ${hypetsubchild}`,
        parentTag: tag,
        color: ASSET_COLOR,
        prefix: hypet,
        parentKey: `${hypet} ${hypetchild}`,
        id: hypetSubChildId,
        tagCollection: subAssetTags,
        moldAssets: moldSubCategory,
      };
    }

    if (moldAssetName !== "") {
      moldAsset = {
        label: `${hypet} ${moldAssetName}`,
        value: `${hypet} ${moldAssetName}`,
        key: `${hypet} ${moldAssetName}`,
        parentTag: tag,
        color: ASSET_COLOR,
        prefix: `${hypet}`,
        parentKey: `${hypet} ${hypetsubchild}`,
        id: "",
        tagCollection: moldAssetTags,
      };
    }

    const existingCompareDataRaw = localStorage.getItem(localStorageCompareKey);

    const existingCompareData = existingCompareDataRaw
      ? JSON.parse(existingCompareDataRaw)
      : {};

    const updatedCompareData = {
      parentAssets: existingCompareData.parentAssets || [],
      plant_id: selectedPlant._id,
      subAssets: existingCompareData.subAssets || [],
      subAssets2: existingCompareData.subAssets2 || [],
      subAssets3: existingCompareData.subAssets3 || [],
      moldAssets: existingCompareData.moldAssets || [],
      tags: existingCompareData.tags || [],
    };

    // if (isMold && mode === "addTag") {
    //   // Adding moldAssets if it doesn't already exists in stored data
    //   if (
    //     !updatedCompareData.moldAssets.find(
    //       (asset: any) => asset.key === moldAssetKey
    //     )
    //   ) {
    //     updatedCompareData.moldAssets.push({
    //       color: ASSET_COLOR,
    //       key: moldAssetKey,
    //       label: moldAssetKey,
    //       value: moldAssetKey,
    //       tagCollection: moldAssetObj.kpiDataPoints.map(
    //         (kpiDataPoints: any) => subAsset3.parentTag + kpiDataPoints.kpitag
    //       ),
    //       prefix: hypet,
    //       parentKey: hypet + " Mold",
    //       parentTag: subAsset3.parentTag,
    //     });
    //   }
    // }

    // Adding parentAsset if it doesn't already exists in stored data
    if (
      !updatedCompareData.parentAssets.find(
        (asset: any) => asset.label === parentAsset.label
      )
    ) {
      updatedCompareData.parentAssets.push(parentAsset);
    }

    // Adding subAsset if it doesn't already exists in stored data
    if (
      !updatedCompareData.subAssets.find(
        (asset: any) => asset.label === subAsset.label
      )
    ) {
      updatedCompareData.subAssets.push(subAsset);
    }

    // Adding subAsset2 if it doesn't already exists in stored data
    if (
      !updatedCompareData.subAssets2.find(
        (asset: any) => asset.label === subAsset2.label
      )
    ) {
      updatedCompareData.subAssets2.push(subAsset2);
    }

    // Adding subAsset3 if it doesn't already exists in stored data
    if (Object.keys(subAsset3).length) {
      if (
        !updatedCompareData.subAssets3.find(
          (asset: any) => asset.label === subAsset3.label
        )
      ) {
        updatedCompareData.subAssets3.push(subAsset3);
      }
    }

    // Adding MoldAsset if it doesn't already exists in stored data
    if (Object.keys(moldAsset).length) {
      if (
        !updatedCompareData.moldAssets.find(
          (asset: any) => asset.label === moldAsset?.label
        )
      ) {
        updatedCompareData.moldAssets.push(moldAsset);
      }
    }

    if (mode === "addTag") {
      // Adding tag if it doesn't already exists in stored data
      if (
        !updatedCompareData.tags.find((tag: any) => tag.label === newTag.label)
      ) {
        updatedCompareData.tags.push(newTag);
      }
    } else {
      let tag = "";
      if (typeof newTag === "string") {
        tag = newTag;
      } else {
        tag = newTag?.tag + newTag?.kpi;
      }
      updatedCompareData.tags = updatedCompareData.tags.filter(
        ({ key }: any) => key !== tag
      );
    }

    localStorage.setItem(
      localStorageCompareKey,
      JSON.stringify(updatedCompareData)
    );

    setCompareAssets(updatedCompareData.tags);
  };

  const addCompareAsset = (tag: string, moldAsset?: string) => {
    const tagParts = tag.split("_");
    const kpiTag = tagParts.at(-2) + "_" + tagParts.at(-1);
    const kpiTagWithAsset = hypet.replace(" ", "_") + "_" + kpiTag;
    const kpiName = kpiTag;

    const moldAssetName = moldAsset?.length ? moldAsset : "";
    let titleArray =  ["HyPET", hypet, hypetchild, hypetsubchild, kpiName]
    if(moldAssetName != "") {
      titleArray.splice(titleArray.length - 1, 0, moldAssetName)
    }

    updateTroubleShootData(
      {
        title: titleArray.join(" - "),
        color: ASSET_COLOR,
        key: tag,
        label: kpiTagWithAsset,
        value: kpiTagWithAsset,
      },
      "addTag",
      moldAssetName
    );
  };

  const removeCompareAsset = (tag: string, moldAsset?: string) => {
    const moldAssetName = moldAsset?.length ? moldAsset : "";
    updateTroubleShootData(tag, "removeTag", moldAssetName);
  };

  useEffect(() => {
    const existingCompareDataRaw = localStorage.getItem(localStorageCompareKey);

    const existingCompareData = existingCompareDataRaw
      ? JSON.parse(existingCompareDataRaw)
      : {};

    setCompareAssets(existingCompareData.tags || []);
  }, []);

  useEffect(() => {
    const finalData = [...finalExcelData];
    finalData.push(excelData);
    const cleanedData = finalData.filter((item) => item && item?.length !== 0);
    setFinalExcelData(cleanedData);
  }, [excelData]);

  useEffect(() => {
    if (
      filteredHyPETSingleAsset &&
      filteredHyPETSingleAsset.description === "Machines"
    ) {
      const kpiDataPoints: any =
        filteredHyPETSingleAsset && filteredHyPETSingleAsset.kpiDataPoints;
      setKpiDataHyPET(kpiDataPoints);
      setExtended(Array(kpiDataPoints.length).fill(false));
      setCollapsed(Array(kpiDataPoints.length).fill(false));
      setIsAssetHasSubCategoryValue(false);
    } else {
      if (
        filteredHyPETSingleAsset &&
        filteredHyPETSingleAsset.description !== "Mold"
      ) {
        const kpiDataPoints: any = filteredHyPETSingleAsset.kpiDataPoints;
        setKpiDataHyPET(kpiDataPoints);
        setExtended(Array(kpiDataPoints.length).fill(false));
        setCollapsed(Array(kpiDataPoints.length).fill(false));
        setIsAssetHasSubCategoryValue(false);
      } else {
        const subCategory: any =
          (filteredHyPETSingleAsset &&
            (filteredHyPETSingleAsset as any).subCategory) ||
          [];
        setIsAssetHasSubCategoryValue(true);
        const kpiDataWithSubcategories = subCategory.map((category: any) => ({
          subCategoryAsset: category.subCategoryAsset,
          kpiDataPoints: category.kpiDataPoints || [],
        }));
        setKpiDataHyPET(kpiDataWithSubcategories);
        setSubCategoryData(kpiDataWithSubcategories);

        setExtended(Array(kpiDataWithSubcategories.length).fill(false));
        setCollapsed(Array(kpiDataWithSubcategories.length).fill(false));
      }
    }
  }, [filteredHyPETSingleAsset, refresh]);

  useEffect(() => {
    setFinalExcelData([]);
  }, [timeDimensions]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (topRef?.current) {
      topRef.current.scrollIntoView({ block: "start", inline: "nearest" });
      topRef.current.scrollTop = 0;
    }
    if(filteredHyPETSingleAsset) {
      setCurrentAssetId(filteredHyPETSingleAsset);
    }
    dispatch({
      type: "LOAD_MESSAGES",
      payload: {
        assetId: filteredHyPETSingleAsset?._id,
        plantId: filteredHyPETSingleAsset?.plant_id,
        useCaseId: "668fe927d72b37f83d989032",
      },
    });
    fetchAnnotations();
  }, [filteredHyPETSingleAsset]);

  const toggleItemState = (key: string) => {
    setExpandedItems((prev: any) => ({
      ...prev,
      [key]: !prev[key],
    }));
    if (collapsedItems[key]) {
      setCollapsedItems((prev: any) => ({
        ...prev,
        [key]: !prev[key],
      }));
    }
  };

  const toggleCallapsedIcon = (key: string) => {
    setCollapsedItems((prev: any) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const toggleCollapse = (index: number) => {
    const newCollapsed = [...collapsed];
    newCollapsed[index] = !newCollapsed[index]; // Toggle collapse state for the specific graph
    setCollapsed(newCollapsed);
  };

  const toggleExtend = (index: number) => {
    const newExtended = [...extended];
    newExtended[index] = !newExtended[index]; // Toggle extended state for the specific graph

    // If extending, ensure the graph is not collapsed
    if (newExtended[index]) {
      const newCollapsed = [...collapsed];
      newCollapsed[index] = false;
      setCollapsed(newCollapsed);
    }
    setExtended(newExtended);
  };

  const fetchAnnotations = async () => {
    if (timeGranularity) {
      const annotationsQuery: any = {
        dimensions: [
          "Annotations.user_annotation",
          "Annotations.datapoint",
          "Annotations.timestamp",
          "Annotations.created_datetime",
          "Annotations.tagName",
          "Annotations.deviceName",
        ],
        order: {
          "Annotations.timestamp": "asc",
        },
        filters: [
          // {
          //   member: "Annotations.tagName",
          //   operator: "contains",
          //   values: neededTags,
          // },
          {
            member: "Annotations.granularity",
            operator: "equals",
            values: [`${timeGranularity}`],
          },
        ],
      };

      if (!hasInvalidCubePayload(annotationsQuery)) {
        const {
          isSuccess,
          isError,
          data: fetchedData,
        } = await fetchAndTrackCubeQuery(cubejsApi, annotationsQuery);
        if (isSuccess) {
          setFetchedAnnotations(fetchedData[0]);
        } else if (isError) {
          dispatch({
            type: "LOAD_SNACKBAR",
            payload: {
              isShow: true,
              message: "Cube query has invalid payload",
              type: "error",
              open: true,
            },
          });
        }
      }
    }
  };

  if (isLoading) return <div><LoadingIndicator text="Loading Report....." /></div>;
  if (error) return <div><ErrorIndicator text={`Error Occured : ${error.message}`}/></div>;

  const appendPaths = {
    //4: hypetSubChildId ? "machineview" : '',
    3: hypetchild && hypetsubchild ? "machineview" : '',
    2: hypetchild ? 'machineview' : '',
  };
  const queryParams = {
    1: { aspid: parentId }, // 1st item query
  };

  const stateParams = {
    2: {
      assetId: hypetId,
      tag: tag,
      hypetId: hypetId,
      parentId: parentId,
      hypetChildId: hypetChildId,
    },
    3: {
      assetId: hypetChildId,
      tag: tag,
      hypetId: hypetId,
      parentId: parentId,
      hypetChildId: hypetChildId,
      hypetSubChildId: hypetSubChildId,
      asset: asset
    },
    4: {
      assetId: hypetSubChildId,
      tag: tag,
      hypetId: hypetId,
      parentId: parentId,
      hypetChildId: hypetChildId,
      hypetSubChildId: hypetSubChildId,
      asset: asset
    },
  };

  if (kpiDataHyPET?.length === 0 || kpiDataHyPET === undefined) {
    return (
      <Grid ref={topRef}>
        <ReportHeader
          pageHeader={`${filteredHyPETSingleAsset.description} Report`}
          
          navigationItem={buildBreadCrumbs(
            plantName,
            ["HyPETs",
              hypet,
              ...(hypetchild ? [hypetchild] : []),
            ...(hypetsubchild ? [hypetsubchild] : []),],
            appendPaths,
            queryParams,
            stateParams
          )}
          setMeasureType={setMeasureType}
          setTimeDimensions={setTimeDimensions}
          setTimeGranularity={setTimeGranularity}
          asset={currentAssetId}
          timeGranularity={timeGranularity}
          dateRange={timeDimensions}
          measure={measureType}
          setCurrentList={setKpiDataHyPET}
          compareAssets={compareAssets}
          removeCompareAsset={removeCompareAsset}
          kpiDataPoints={hypet_single_assets?.data?.kpiDataPoints}
          setUpdatedKpiList={setUpdatedKpiList}
          updatedKpiList={updatedKpiList}
          setQueryKey={setQueryKey}
          subCategoryData={subCategoryData}
          isAssetHasSubCategory={isAssetHasSubCategoryValue}
        />
        <Box>
          SelectedAssets
          {compareAssets.map((asset) => asset._id)}
        </Box>
        <Box sx={{ mt: 2, mx: 2, my: 8 }} style={{ marginTop: "0px" }}>
          <Grid container spacing={2} padding={1}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  spacing={1}
                  padding={1}
                  style={{ background: "#293368", margin: "4px 4px 4px 12px" }}
                >
                  NO KPI DATAPOINT
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    );
  } else {
    return (
      <Grid ref={topRef}>
        <ReportHeader
          pageHeader={`${filteredHyPETSingleAsset.description} Report`}
          navigationItem={buildBreadCrumbs(
            plantName,
            ["HyPETs",
              hypet,
              ...(hypetchild ? [hypetchild] : []),
            ...(hypetsubchild ? [hypetsubchild] : []),],
            appendPaths,
            queryParams,
            stateParams
          )}
          setMeasureType={setMeasureType}
          setTimeDimensions={setTimeDimensions}
          setTimeGranularity={setTimeGranularity}
          timeGranularity={timeGranularity}
          asset={currentAssetId}
          finalExcelData={finalExcelData}
          setCurrentList={setKpiDataHyPET}
          setRefresh={setRefresh}
          refresh={refresh}
          subCategoryData={subCategoryData}
          compareAssets={compareAssets}
          removeCompareAsset={removeCompareAsset}
          kpiDataPoints={hypet_single_assets?.data?.kpiDataPoints}
          kpiChangeSummary={hypet_single_assets?.data.kpiChangeSummary}
          setUpdatedKpiList={setUpdatedKpiList}
          updatedKpiList={updatedKpiList}
          setQueryKey={setQueryKey}
          isAssetHasSubCategory={isAssetHasSubCategoryValue}
        />
        <ContentSubHeader>
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {kpiDataHyPET?.map((item: any, index: number) =>
                    item.subCategoryAsset ? (
                      <Accordion style={{ marginBottom: "16px" }}  onChange={(_, isExpanded) =>
                          setExpandedMainAccordion(isExpanded ? index : null)
                      }>
                        <AccordionSummary
                          expandIcon={
                            expandedMainAccordion === index ? (
                              <ExpandLessIcon style={{ color: "#00FF00" }} /> // green icon when expanded
                            ) : (
                              <ExpandMoreIcon style={{ color: "#FFFFFF" }} /> // white when collapsed
                            )
                          }
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          <Typography variant="h4">
                            {item.subCategoryAsset}
                          </Typography>
                        </AccordionSummary>
                        {expandedMainAccordion === index && (<AccordionDetails
                          style={{ padding: "8px", backgroundColor: "#1f2655" }}
                        >
                          {item.kpiDataPoints?.map(
                            (subItem: any, subIndex: number) => (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                spacing={1}
                                padding={0}
                                key={subItem.kpiName}
                                style={{ flexGrow: 1, marginBottom: "10px" }}
                              >
                                <AccordionKPIBlock
                                  title={subItem.kpiName}
                                  unit={subItem.kpiUnit}
                                  onToggleExtend={() =>
                                    toggleItemState(`${index}-${subIndex}`)
                                  }
                                  onToggleCollapse={() =>
                                    toggleCallapsedIcon(`${index}-${subIndex}`)
                                  }
                                  isCollapsed={
                                    !!collapsedItems[`${index}-${subIndex}`]
                                  }
                                  isExtended={
                                    !!expandedItems[`${index}-${subIndex}`]
                                  }
                                  //tag={tagGeneration(filteredHyPETSingleAsset?.devices[0].tag as any, subItem.kpitag as any)}
                                  // tag={
                                  //   Array.isArray(subItem?.kpitag)
                                  //     ? subItem?.kpitag?.map(
                                  //         (kpi: any) =>
                                  //           `${filteredHyPETSingleAsset?.devices[0]?.tag}${kpi}`
                                  //       )
                                  //     : `${filteredHyPETSingleAsset?.devices[0]?.tag}${subItem?.kpitag}`
                                  // }
                                  tag={
                                    Array.isArray(subItem?.kpitag)
                                      ? subItem?.kpitag?.map(
                                          (kpi: any) => `${tag}${kpi}`
                                        )
                                      : `${tag}${subItem?.kpitag}`
                                  }
                                  dateRange={timeDimensions}
                                  granularity={timeGranularity}
                                  measureType={measureType}
                                  setExcelData={setExcelData}
                                  fetchedAnnotations={fetchedAnnotations}
                                  addCompareAsset={addCompareAsset}
                                  removeCompareAsset={removeCompareAsset}
                                  compareAssets={compareAssets}
                                  isMoldAssetName={item.subCategoryAsset}
                                  renderChart={expandedMainAccordion === index}
                                />
                              </Grid>
                            )
                          )}
                        </AccordionDetails>)}
                      </Accordion>
                    ) : (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        spacing={0}
                        padding={0}
                        style={{ flexGrow: 1, marginBottom: "10px" }}
                      >
                        <AccordionKPIBlock
                          title={`${item.kpiName}`}
                          data={item.data}
                          unit={item.kpiUnit}
                          isCollapsed={collapsed[index]}
                          isExtended={extended[index]}
                          onToggleCollapse={() => toggleCollapse(index)}
                          onToggleExtend={() => toggleExtend(index)}
                          tag={
                            Array.isArray(item?.kpitag)
                              ? item?.kpitag?.map((kpi: any) => `${tag}${kpi}`)
                              : `${tag}${item?.kpitag}`
                          }
                          dateRange={timeDimensions}
                          granularity={timeGranularity}
                          measureType={measureType}
                          setExcelData={setExcelData}
                          fetchedAnnotations={fetchedAnnotations}
                          addCompareAsset={addCompareAsset}
                          removeCompareAsset={removeCompareAsset}
                          compareAssets={compareAssets}
                        />
                      </Grid>
                    )
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ContentSubHeader>
      </Grid>
    );
  }
}

export default TimeSeriesView;
